export const HOME_INDICATOR_TOTAL_EVENTS = 'home_total_events';
export const HOME_INDICATOR_FACEBOOK_RATING = 'home_facebook_rating';
export const HOME_INDICATOR_GOOGLE_COMMENTS_RATING = 'home_google_comments_rating';
export const CONFIG_COMMERCIAL_NUMBER = 'order_info_commercial_number';
//export const API_BASE_URL = "https://localhost:7003/api";
 export const API_BASE_URL = "https://api.basico.app/api";
